export const DRONE_MAX_SPEED = 5.5;

export function maxTowSpeed(towedMass: number): number {
  return DRONE_MAX_SPEED / (1 + Math.max(0, towedMass) / 18);
}

export function calculateCableTension(
  distance: number,
  cableLength: number,
  towedMass: number,
  relativeSpeed: number,
): number {
  const extension = Math.max(0, distance - cableLength);
  return extension * 0.72 + Math.max(0, towedMass) * Math.abs(relativeSpeed) * 0.075;
}
